import script from "./SalesCards.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesCards.vue?vue&type=script&setup=true&lang=js"

import "./SalesCards.vue?vue&type=style&index=0&id=32d0d3d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32d0d3d8"]])

export default __exports__